/*
 * @Author: your name
 * @Date: 2021-02-02 11:02:57
 * @LastEditTime: 2021-03-09 14:08:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\side-fixed\i18n.js
 */
export default {
  'zh-CN': {
    feedback: '意见反馈',
    goTop: '返回顶部',
    processTitle: '系统任务进程',
    helpCenter: '帮助中心',
    myCustomerService: '我的客服',
    iKonw: '知道了',
    feedbackTips: '如果您有操作问题或优化建议，请点击这里告诉我们，期待您的反馈！'
  },
  en: {
    feedback: 'Feedback',
    goTop: 'Back to top',
    processTitle: 'System task process',
    helpCenter: 'Help Center',
    myCustomerService: 'My customer service',
    iKonw: 'Got it',
    feedbackTips: 'If you have any operation problems or optimization suggestions, please click here to tell us. We look forward to your valuable feedback!'
  },
  ja: {
  }
}
